import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'content-with-label',
  template: `
    <label class="lx-label" [ngClass]="{ required: required }">{{
      label
    }}</label>
    <ng-content></ng-content>
  `,
  styleUrls: ['content-with-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentWithLabelComponent {
  @Input({ required: true }) label: string;
  @Input() gap = 4;
  @Input() required = false;

  @HostBinding('style.gap.px') get gapStyle() {
    return this.gap;
  }
}
